const Earnings = () => import('@/pages/earnings/earnings.vue');

export default [
  {
    path: '/earnings/earnings',
    name: 'earnings',
    component: Earnings,
  }
]